<template>
  <v-combobox
    v-model="input"
    v-bind="$attrs"
    class="base-combobox"
    :label="_label"
    :rules="validationRules"
    @change="$emit('input', $event)"
  />
</template>

<script>
export default {
  name: 'BaseComboBox',
  props: {
    label: {
      type: String,
      required: true
    },
    rules: {
      type: Array,
      default: () => ([])
    },
    maxLength: {
      type: Number,
      default: null
    },
    restrictLength: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    uppercase: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      input: this.$attrs.value
    }
  },
  computed: {
    _label () {
      return this.required ? this.label + '*' : this.label
    },
    validationRules () {
      const rules = [...this.rules]
      if (this.required) {
        rules.push(value => !!value || 'Required')
      }
      if (this.maxLength) {
        rules.push(value => (value && value.length <= this.maxLength) || `Length must be less than ${this.maxLength}`)
      }
      return rules
    }
  },
  watch: {
    value () {
      this.input = this.value
    }
  }
}
</script>

<style lang="scss" scoped>
  @import './src/styles/variables';

  .base-combobox {
    min-height: 35px !important;
    font-size: $font-small !important;

    label {
      text-transform: uppercase !important;
      font-size: $font-small;
    }
  }
</style>
